export const SHOULD_SHOW_MESSAGE = 'SHOULD_SHOW_MESSAGE';

const shouldShowMessageAction = (shouldShowMessage) => (dispatch) => {
    dispatch({
        type: SHOULD_SHOW_MESSAGE,
        shouldShowMessage
    });
};

export default shouldShowMessageAction;
